import React from 'react'
import styled from 'styled-components'

import { Customer } from 'types/Customer'

import AlertIconWithCount from 'pages/shared/Alert/IconWithCount' // WIP: rename file to AlertIconWithCount
import { phoneNumber } from 'helpers/formatters'

export type Props = {
    markerInfo: Required<Customer>
  }

const CriticalAndMajorAlertsMarker = ({ markerInfo } : Props) => {
  return (
    <S.MapInfo>
      <S.Name href={`customers/${markerInfo.id}`} data-route data-testid="customer-link">
        {markerInfo.firstName} {markerInfo.lastName}
      </S.Name>
      <div>
        {markerInfo.address1 && <span> {markerInfo.address1} </span> }
        {markerInfo.address2 && <span> {markerInfo.address2} </span> }
      </div>
      <div>
        {markerInfo.city && <span> {markerInfo.city},  </span> }
        {markerInfo.state && <span> {markerInfo.state} </span> }
        {markerInfo.zip && <span> {markerInfo.zip} </span> }
      </div>
      <S.Link href={`mailto:${markerInfo.email}`}>{markerInfo.email} </S.Link>
      <S.Link href={`tel:${markerInfo.phone}`}>{phoneNumber(markerInfo.phone)} </S.Link>
      {
        markerInfo.devices.map(info => (
          (info.criticalAlertCount !== 0 || info.majorAlertCount !== 0 || info.sdaMajorAlertCount !== 0 || info.sdaCriticalAlertCount !== 0) &&
          <S.Device key={info.deviceId}>
            {
              <>
                <S.line />
                <S.DeviceId href={`customers/${markerInfo.id}/systems/${info.deviceId}`} data-testid="device-link">{info.deviceId}</S.DeviceId>
                <S.AlertIconWithCount severity="critical" count={info.criticalAlertCount} />
                <S.AlertIconWithCount severity="critical-sda" count={info.sdaCriticalAlertCount} />
                <S.AlertIconWithCount severity="major" count={info.majorAlertCount} />
                <S.AlertIconWithCount severity="major-sda" count={info.sdaMajorAlertCount} />
              </>
            }
          </S.Device>
        ))
      }
    </S.MapInfo>
  )
}

export default CriticalAndMajorAlertsMarker

const S = {
  MapInfo: styled.div`
    display:grid;
    overflow: hidden;
  `,
  Name: styled.a`
    font-size: 20px;
    margin-bottom: 8px;
  `,
  FirstName: styled.span`
    margin-left: 5px;
  `,
  Link: styled.a`
    margin-top: 10px;
  `,
  DeviceId: styled.a`
    padding-right: 10px;
  `,
  Device: styled.div`
    margin-top: 10px;
  `,
  line: styled.hr`
    margin-top: 0;
    margin-bottom: 10px;
  `,
  AlertIconWithCount: styled(AlertIconWithCount)`
    display: inline-block;
  `
}
